import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import InfiniteScroll from 'react-infinite-scroller';
import {Item, Loader} from 'semantic-ui-react';

import {fetchAPI} from '../actions/api';
import {haveDifferentKeys} from '../utils/compare';

const loader = <Item key="APIList-loader">
    <Loader active={true} inline="centered"/>
</Item>;

class APIList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            url: props.url,
            items: []
        };
    }

    mapResponse = response => {
        const {mapResponseToState} = this.props, {items, url} = mapResponseToState(response, this.state),
            newItems = items.filter(({key}) => !this.state.items.find(i => i.key === key));
        return this.setState({
            items: this
                .state
                .items
                .concat(newItems),
            url
        });
    };

    loadMore = () => {
        const {url} = this.state;
        return this
            .props
            .fetchAPI(url)
            .then(this.mapResponse);
    };

    toComponent = item => React.createElement(this.props.component, item);

    shouldComponentUpdate(props, {items, url}) {
        return url !== this.state.url || haveDifferentKeys(items, this.state.items);
    }

    render() {
        const {className} = this.props, {items, url} = this.state,
            hasMore = Boolean(url);
        return <Item.Group
            as={InfiniteScroll}
            className={classNames(className, 'APIList')}
            divided={true}
            hasMore={hasMore}
            initialLoad={true}
            loader={loader}
            loadMore={this.loadMore}
            pageStart={0}
            relaxed="very"
            threshold={640}>
            {items.map(this.toComponent)}
        </Item.Group>;
    }
}

APIList.propTypes = {
    component: PropTypes.func.isRequired,
    fetchAPI: PropTypes.func.isRequired,
    mapResponseToState: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired
};

export default connect(null, {fetchAPI})(APIList);


// WEBPACK FOOTER //
// ./src/containers/APIList.js